import * as angular from 'angular';
import { reloadCurrentRoute } from '../../../../../../src/app/shared/utils/navigate-force-reload';

class Forward {
    [x: string]: any;
 	 static $inject = ['InboundNumbersService','$stateParams','$state','Toast', 'Router'];
    constructor(InboundNumbersService, $stateParams, $state, Toast, Router) {
        this.InboundNumbersService = InboundNumbersService;
        this.$stateParams = $stateParams;
        this.state = $state;
        this.toast = Toast;
        this.router = Router;
    }

    $onInit() {
        this.settings = angular.copy(this.settings);
    }
    save(){
      const updatedSettings = {...this.settings, checked: true};
      this.settings = updatedSettings;
        this.InboundNumbersService.setNumberSettings({id: this.msisdnid},{forwardCallConfiguration:this.settings},()=>{
            this.hide();
            this.toast.success('CHANGES_SAVED');
            reloadCurrentRoute(this.router);
        });
    }
}

export default {
    controller: Forward,
    template : require('./phone.details.forward.html'),
    bindings: {
        hide: '&',
        settings: '<',
        msisdnid: '<'
    }
};
